import { render, staticRenderFns } from "./pageCatalogue.vue?vue&type=template&id=85bf00d0&scoped=true&"
import script from "./pageCatalogue.vue?vue&type=script&lang=js&"
export * from "./pageCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./pageCatalogue.vue?vue&type=style&index=0&id=85bf00d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bf00d0",
  null
  
)

export default component.exports